import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Wrench } from 'lucide-react';
import {
    placeholderPageStyles,
    placeholderWrenchColor,
    placeholderWrenchStyle,
} from './PlaceholderPage.styles';
import { useTranslation } from 'react-i18next';

const PlaceholderPage: React.FC<{ title: string }> = ({ title }) => {
    const { t } = useTranslation();
    return (
        <Box sx={placeholderPageStyles.root}>
            <Wrench size={48} color={placeholderWrenchColor} style={placeholderWrenchStyle} />
            <Typography variant="h5" fontWeight={700} gutterBottom>{title}</Typography>
            <Typography color="text.secondary">{t('placeholderPage.underConstruction')}</Typography>
        </Box>
    );
};

export default PlaceholderPage;
